module.exports = __webpack_public_path__ + "img/image_part_007.c215679d.jpg";